var map = {
	"./de-DE.json": [
		2395,
		2
	],
	"./en-GB.json": [
		2396,
		3
	],
	"./en-US.json": [
		2397,
		4
	],
	"./es-419.json": [
		2398,
		5
	],
	"./es-ES.json": [
		2399,
		6
	],
	"./fr-CA.json": [
		2400,
		7
	],
	"./fr-FR.json": [
		2401,
		8
	],
	"./id-ID.json": [
		2402,
		9
	],
	"./it-IT.json": [
		2403,
		10
	],
	"./ja-JP.json": [
		2404,
		11
	],
	"./nl-NL.json": [
		2405,
		12
	],
	"./pt-BR.json": [
		2406,
		13
	],
	"./zh-CN.json": [
		2407,
		14
	],
	"./zh-Hans-CN.json": [
		2408,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1188;
module.exports = webpackAsyncContext;